import { Cancel, Save } from '@mui/icons-material';
import { Divider, Grid, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomButton, {
  CustomSelect,
  CustomTextField,
} from '../../../../Common/Components/Controls/InputControls';
import { capitalizeWords } from '../../../../Helpers/UtilityMethods';
import { Product, Subscription } from '../../../Common/CommonModel';
import { commonService } from '../../../Common/CommonService';
import {
  CardWrapper,
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import AzureSearchServiceConstants from '../Common/Constants';
import { AzureSearchService } from '../Model/AzureSearchServiceModel';
import {
  CreateOrEditProps,
  ParamProps,
} from '../Model/AzureSearchServiceProps';
import { azureSearchServiceService } from '../AzureSearchServiceService';
import { Loader } from '../../../../Common/Components/Loader';
import { showToast } from '../../../../lib/toast';

const AzureSearchServiceFarm: React.FC<CreateOrEditProps> = ({
  AzureSearchService,
  setAzureSearchService,
  AddOrEditAzureSearchService,
  showOperationbutton,
  showBackbutton,
  operation,
}) => {
  const [AzureRegions, setRegions] = useState<string[]>([]);
  const [Products, setProducts] = useState<Product[]>([]);
  const [Subscriptions, setSuscriptions] = useState<Subscription[]>([]);
  const [loading, setloading] = useState(true);

  useEffect(() => {
    const InitData = async () => {
      const loadAzureRegions = async () => {
        const azureRegions = await commonService.getAzureRegions();
        setRegions(azureRegions);
      };

      const loadSubscriptions = async () => {
        const subscriptions = await commonService.getSubscriptions();
        setSuscriptions(subscriptions.Items);
      };

      const loadProducts = async () => {
        const products = await commonService.getProducts();
        setProducts(products.Items);
      };
      setloading(true);
      await loadAzureRegions().catch((err) => console.log(err));
      await loadProducts().catch((err) => console.log(err));
      await loadSubscriptions().catch((err) => console.log(err));
      setloading(false);
    };
    InitData();
  }, []);

  return (
    <>
      {loading ? (
        <Loader loading={loading} />
      ) : (
        <>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <CardWrapper>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                  {operation.charAt(0).toUpperCase() + operation.slice(1)} Azure
                  Search Service
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      Azure Search Service Name
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      disabled={operation !== 'create'}
                      value={AzureSearchService.Name}
                      onChange={(e) =>
                        setAzureSearchService({
                          ...AzureSearchService,
                          Name: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Resource Group</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomTextField
                      value={AzureSearchService.ResourceGroup}
                      onChange={(e) =>
                        setAzureSearchService({
                          ...AzureSearchService,
                          ResourceGroup: e.target.value,
                        })
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Product Id</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={AzureSearchService.ProductID}
                      onChange={(e) =>
                        setAzureSearchService({
                          ...AzureSearchService,
                          ProductID: e.target.value,
                        })
                      }
                    >
                      {Products.map((product) => (
                        <MenuItem key={product.Id} value={product.Id}>
                          {product.Id}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Subscription</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={AzureSearchService.Subscription}
                      onChange={(e) =>
                        setAzureSearchService({
                          ...AzureSearchService,
                          Subscription: e.target.value,
                        })
                      }
                    >
                      {Subscriptions.map((subscription) => (
                        <MenuItem
                          key={subscription.Name}
                          value={subscription.Name}
                        >
                          {subscription.Name}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center" mt={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Azure Region</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CustomSelect
                      value={AzureSearchService.AzureRegion}
                      onChange={(e) =>
                        setAzureSearchService({
                          ...AzureSearchService,
                          AzureRegion: e.target.value,
                        })
                      }
                    >
                      {AzureRegions.map((region) => (
                        <MenuItem key={region} value={region}>
                          {region}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </Grid>
                </Grid>
              </CardWrapper>
            </Grid>
          </Grid>
          <FooterWrapper>
            <FooterContainer>
              <Grid item xs={12} sm="auto">
                {showOperationbutton(AddOrEditAzureSearchService)}
              </Grid>
              <Grid item xs={12} sm="auto">
                {showBackbutton()}
              </Grid>
            </FooterContainer>
          </FooterWrapper>
        </>
      )}
    </>
  );
};

export default function AzureSearchServiceOps() {
  const [AzureSearchService, setAzureSearchService] =
    useState<AzureSearchService>({
      Name: '',
      ProductID: '',
      ResourceGroup: '',
      Subscription: '',
      AzureRegion: '',
    });
  const history = useHistory();

  const param = useParams<ParamProps>();
  const Operation = param.Operation.toLocaleLowerCase();

  useEffect(() => {
    const GetAzureSearchService = async () => {
      try {
        await azureSearchServiceService
          .getAzureSearchService(param.Name)
          .then((AzureSearchService) =>
            setAzureSearchService(AzureSearchService),
          );
      } catch {
        showToast({
          type: 'error',
          title: AzureSearchServiceConstants.AzureSearchServiceSaveFailed,
        });
      }
    };

    if (Operation === 'edit') {
      GetAzureSearchService();
    }
  }, [Operation, param.Name]);

  const validateAzureSearchService = (
    AzureSearchService: AzureSearchService,
  ) => {
    if (
      AzureSearchService.Name.trim() === '' ||
      AzureSearchService.AzureRegion.trim() === '' ||
      AzureSearchService.ProductID.trim() === '' ||
      AzureSearchService.Subscription.trim() === '' ||
      AzureSearchService.ResourceGroup.trim() === ''
    ) {
      showToast({
        type: 'error',
        title: 'all field are mandatory',
      });
      return false;
    }
    return true;
  };
  const handleCancel = async () => {
    history.push('/SearchService');
  };

  const AddOrEditAzureSearchService = async () => {
    if (validateAzureSearchService(AzureSearchService)) {
      try {
        await azureSearchServiceService.setAzureSearchService(
          AzureSearchService,
        );
        handleCancel();
        showToast({
          title: AzureSearchServiceConstants.AzureSearchServiceSaveSuc,
          type: 'success',
        });
      } catch (error) {
        console.log(error);
        showToast({
          type: 'error',
          title: (error as Error).message,
        });
      }
    }
  };

  const showBackOption = () => {
    return (
      <CustomButton
        startIcon={<Cancel />}
        onClick={handleCancel}
        label="Cancel"
      />
    );
  };

  const showOpsOption = (
    handleOperation: React.MouseEventHandler<HTMLButtonElement>,
  ) => {
    return (
      <CustomButton
        startIcon={<Save />}
        onClick={handleOperation}
        label="Save"
      />
    );
  };

  return (
    <div>
      <PaperWrapper>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {capitalizeWords(Operation)} Azure Search Service
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <AzureSearchServiceFarm
          AzureSearchService={AzureSearchService}
          setAzureSearchService={setAzureSearchService}
          AddOrEditAzureSearchService={AddOrEditAzureSearchService}
          showOperationbutton={showOpsOption}
          showBackbutton={showBackOption}
          operation={Operation}
        />
      </PaperWrapper>
    </div>
  );
}
